import { forwardRef, type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../cn";

const badge = cva(
  "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-caption font-medium",
  {
    variants: {
      tone: {
        shakti: "border-saffron/40 bg-saffron/10 text-saffron",
        sattva: "border-forest/40 bg-forest/10 text-forest",
        amrita: "border-gold/40 bg-gold/10 text-gold",
        agni: "border-terracotta/40 bg-terracotta/10 text-terracotta",
        neutral: "border-charcoal/20 bg-sand text-ink",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badge> {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { className, tone, ...rest },
  ref,
) {
  return <span ref={ref} className={cn(badge({ tone }), className)} {...rest} />;
});
